import React from 'react';

const Goals: React.FC = () => {
    return (
        <div className="container mt-5">
            <h1>Goals Tracker</h1>
            <p>Track your financial goals and monitor your progress.</p>
            <p>Use this section to add, edit, and view your goals.</p>
        </div>
    );
};

export default Goals;